"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
var _utils = require("../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var PaymentError = function PaymentError(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    "data-name": "Layer 1",
    viewBox: "0 0 450 450"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:".concat((0, _utils.checkRebrand)("#7D74CC", "#40ba86"), "}.cls-2{opacity:.2}.cls-3{fill:").concat((0, _utils.checkRebrand)("#09ADEA", "#065d5b"), "}"))), /*#__PURE__*/React.createElement("path", {
    d: "M26 123.37a3 3 0 0 1-3-3v-13.52a3 3 0 0 1 6 0v13.51a3 3 0 0 1-3 3.01ZM26 155.84a3 3 0 0 1-3-3v-13.5a3 3 0 1 1 6 0v13.5a3 3 0 0 1-3 3ZM16.52 132.86H3a3 3 0 0 1 0-6h13.52a3 3 0 0 1 0 6ZM49 132.86H35.46a3 3 0 1 1 0-6H49a3 3 0 1 1 0 6ZM413 331.79a4.29 4.29 0 0 1-4.29-4.29v-19.23a4.29 4.29 0 0 1 8.58 0v19.23a4.29 4.29 0 0 1-4.29 4.29ZM413 378a4.29 4.29 0 0 1-4.29-4.29v-19.2a4.29 4.29 0 0 1 8.58 0v19.23A4.29 4.29 0 0 1 413 378ZM399.51 345.3h-19.23a4.29 4.29 0 1 1 0-8.58h19.23a4.29 4.29 0 1 1 0 8.58ZM445.71 345.3h-19.23a4.29 4.29 0 1 1 0-8.58h19.23a4.29 4.29 0 1 1 0 8.58Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 179.73,
    cy: 237.8,
    r: 142.94,
    className: "cls-3"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 225.27,
    cy: 216.42,
    r: 142.94,
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.27 363.59c-81.15 0-147.17-66-147.17-147.17s66-147.17 147.17-147.17 147.17 66 147.17 147.17-66.02 147.17-147.17 147.17Zm0-285.88c-76.49 0-138.72 62.22-138.72 138.71s62.23 138.72 138.72 138.72S364 292.91 364 216.42 301.76 77.71 225.27 77.71Z",
    style: {
      fill: (0, _utils.checkRebrand)("#09ADEA", '#0a5e5c')
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.51 336.67a142.93 142.93 0 0 1-95.4-249.38 142.95 142.95 0 1 0 156.74 235.56 142.31 142.31 0 0 1-61.34 13.82Z",
    className: "cls-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m237 216.4 40.09-40.08a7.48 7.48 0 1 0-10.58-10.58l-40.09 40.09-40.09-40.09a7.48 7.48 0 0 0-10.58 10.58l40.09 40.08-40.09 40.09a7.48 7.48 0 1 0 10.58 10.57L226.44 227l40.09 40.08a7.48 7.48 0 0 0 10.58-10.57Z",
    style: {
      fill: '#f05141'
    }
  }));
};
var _default = exports["default"] = PaymentError;